module.exports = __webpack_public_path__ + "img/globe.a0f25fc7.gif";